var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"make-bracelet"},[_c('div',{staticClass:"make-bracelet-step-box"},[(_vm.active ==0)?_c('step1'):_vm._e(),(_vm.active ==1)?_c('step2'):_vm._e(),(_vm.active ==2)?_c('step3'):_vm._e(),(_vm.active ==3)?_c('step4'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }